import React from 'react';

export const SvgDispAll = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 1236 653'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='DispAll_svg__a'>
        <path d='M131 1494h1239v655H131z' />
      </clipPath>
    </defs>
    <g
      transform='matrix(.99793 0 0 .99758 -130.94 -1490.6)'
      clipPath='url(#DispAll_svg__a)'
    >
      <path
        d='M133.5 1604.8c0-59.84 48.503-108.34 108.34-108.34h1017.3c59.84 0 108.34 48.5 108.34 108.34v433.32c0 59.84-48.5 108.34-108.34 108.34H241.84c-59.832 0-108.34-48.5-108.34-108.34z'
        fillRule='evenodd'
        stroke='#4472c4'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
    </g>
    <g
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 312.25
      }}
      aria-label='\u5168\u8ECA\u4E21'
    >
      <path d='M305.12 216.75q-34.939 49.397-68.674 72.288h151.81q-39.759-21.686-83.132-72.288zm-79.517 79.517q-16.867 9.638-39.759 21.686l-12.048-25.301q81.927-34.939 120.48-109.64l26.506 3.614q9.638 3.615-1.205 6.024l-2.41 3.615q54.217 66.264 128.91 89.156l-12.047 26.506q-14.458-4.82-40.963-20.482v20.482h-71.083v40.963h78.312v22.89h-78.312v46.988h110.84v22.89h-245.78v-22.89h110.84V375.78h-78.312V352.89h78.312v-40.963h-72.288zM495.48 234.82v-22.891h110.84v-26.506h22.891q9.638 1.205 1.205 7.229v19.277h108.43v22.89h-108.43v24.097h84.336v109.64h-24.096v-6.024h-60.24v24.096h125.3v22.89h-125.3v50.603H606.32v-50.602h-125.3v-22.891h125.3v-24.096h-60.24v7.229h-24.096V258.92h84.336v-24.096zm134.94 108.43h60.24v-22.891h-60.24zm-84.336-42.168h60.24v-22.891h-60.24zm84.336 0h60.24v-22.891h-60.24zm-84.336 42.168h60.24v-22.891h-60.24zM938.85 226.39v37.349h106.02v177.11q0 16.867-16.867 16.867h-37.349l-3.614-22.891h28.915q4.819 0 4.819-4.82v-143.37h-81.927v100h28.915V317.96h22.89q9.64 1.205 1.206 7.229v95.18h-24.096v-10.843h-81.927v20.482h-24.096v-112.05h22.89q9.64 1.204 1.205 7.228v61.445h28.915v-99.999h-81.927v169.88h-24.096v-192.77h106.02v-37.349h-120.48v-22.89h265.06v22.89z' />
    </g>
  </svg>
);
